import { Amplify } from "aws-amplify";
import { client, graphqlOperation } from "../libs/amplifyAPI";
import { AWS_CONFIGURATION } from './../config';
import createTodoMutation from './../mutations/createTodo';
import deleteTodoMutation from './../mutations/deleteTodo';
import updateTodoMutation from './../mutations/updateTodo';
import createdTodo from '../subscriptions/createdTodo';
import deletedTodo from '../subscriptions/deletedTodo';
import updatedTodo from '../subscriptions/updatedTodo';
import { formatRequest } from './../libs/general';

Amplify.configure(AWS_CONFIGURATION);

export const createTodo = async (body) => {
	try {
		const list = await client.graphql(graphqlOperation(createTodoMutation, {
			body: formatRequest(body)
		}));
		return list.data.createTodo.items;
	} catch (e) {
		if (e instanceof Error) return e;
		else return new Error('Failed to create todo');
	}
}

export const updateTodo = async (todoId, body) => {
	try {
		const item = await client.graphql(graphqlOperation(updateTodoMutation, {
			todoId: formatRequest(todoId),
			body: formatRequest(body)
		}));
		return item.data.updateTodo;
	} catch (e) {
		if (e instanceof Error) return e;
		else return new Error('Failed to update todo');
	}
}

export const deleteTodo = async (todoId) => await client.graphql(graphqlOperation(deleteTodoMutation, { todoId }));

export const createdTodoSubscription = async (callback) => {
  try {
    console.log('Setting up createdTodo subscription');
    const subscription = client.graphql(graphqlOperation(createdTodo));
    
    return subscription.subscribe({
      next: (result) => {
        console.log('Received createdTodo subscription event:', result);
        if (result?.data?.createdTodo) {
          callback(result.data.createdTodo);
        }
      },
      error: (error) => {
        console.error('Error in createdTodo subscription:', error);
      }
    });
  } catch (error) {
    console.error('Failed to set up createdTodo subscription:', error);
  }
};

export const deletedTodoSubscription = async (callback) => {
  try {
    console.log('Setting up deletedTodo subscription');
    const subscription = client.graphql(graphqlOperation(deletedTodo));
    
    return subscription.subscribe({
      next: (result) => {
        console.log('Received deletedTodo subscription event:', result);
        if (result?.data?.deletedTodo?.todoId) {
          callback(result.data.deletedTodo.todoId);
        }
      },
      error: (error) => {
        console.error('Error in deletedTodo subscription:', error);
      }
    });
  } catch (error) {
    console.error('Failed to set up deletedTodo subscription:', error);
  }
};

export const updatedTodoSubscription = async (callback) => {
  try {
    console.log('Setting up updatedTodo subscription');
    const subscription = client.graphql(graphqlOperation(updatedTodo));
    
    return subscription.subscribe({
      next: (result) => {
        console.log('Received updatedTodo subscription event:', result);
        if (result?.data?.updatedTodo) {
          callback(result.data.updatedTodo);
        }
      },
      error: (error) => {
        console.error('Error in updatedTodo subscription:', error);
      }
    });
  } catch (error) {
    console.error('Failed to set up updatedTodo subscription:', error);
  }
};